import React from 'react';
import './TaperedDivider.css';

const TaperedDivider = ({ 
  text, 
  count, 
  padding = '12px 0',
  textColor = '#666666',
  lineColor = '#d3d3d3',
  fontSize = '18px',
  fontWeight = 600
}) => {
  const title = count !== null && count !== undefined ? `${text} (${count})` : text;

  return (
    <div 
      className="tapered-divider-container" 
      style={{ padding }}
    >
      {/* LEFT TAPERED LINE */}
      <div className="tapered-line left">
        <svg 
          className="tapered-svg" 
          preserveAspectRatio="none"
          viewBox="0 0 100 2"
        >
          <polygon 
            points="0,1 100,0 100,2" 
            fill={lineColor}
          />
        </svg>
      </div>

      {/* CENTER TEXT */}
      <div className="tapered-text-container">
        <div 
          className="tapered-text"
          style={{
            fontSize,
            fontWeight,
            color: textColor,
            letterSpacing: '0.8px'
          }}
        >
          {title.toUpperCase()}
        </div>
      </div>

      {/* RIGHT TAPERED LINE */}
      <div className="tapered-line right">
        <svg 
          className="tapered-svg" 
          preserveAspectRatio="none"
          viewBox="0 0 100 2"
        >
          <polygon 
            points="100,1 0,0 0,2" 
            fill={lineColor}
          />
        </svg>
      </div>
    </div>
  );
};

export default TaperedDivider;